/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE.
*/

import { sva } from "@panda/css";

export const tag = sva({
	slots: ["anchor", "label"],
	base: {
		anchor: {
			"&&": {
				backgroundColor: "var(--tag-background-color, token(colors.eds.fill.secondary.default))",
				display: "inline-flex",
				alignItems: "center",
				borderRadius: "eds.borderRadius.full",
				transition: "background token(animations.eds.duration.200) token(animations.eds.easing.easeInOutQuad)",
				backdropFilter: "blur(50px)",
				_focusVisible: {
					outline: "2px solid white",
				},
			},

			"&&.hoverable:hover": {
				background: "var(--tag-hover-background-color, token(colors.eds.fill.secondary.hover))",
			},
		},
		label: {
			"&&": {
				color: "var(--tag-color, token(colors.eds.text.contrast))",
			},
			textStyle: "uiMD",
		},
	},
	variants: {
		size: {
			lg: {
				anchor: {
					minHeight: "eds.dimension.40",
					paddingBlock: "eds.dimension.4",
					paddingInline: "eds.dimension.20",
					mdDown: {
						minHeight: "eds.dimension.32",
						paddingBlock: "eds.dimension.4",
						paddingInline: "eds.dimension.12",
					},
				},
			},
			md: {
				anchor: {
					minHeight: "eds.dimension.32",
					paddingBlock: "eds.dimension.4",
					paddingInline: "eds.dimension.16",
				},
			},
			sm: {
				anchor: {
					paddingBlock: "eds.dimension.2",
					paddingInline: "eds.dimension.12",
				},
			},
			uiSM: {
				anchor: {
					"&&": {
						background: "var(--tag-background-color, token(colors.eds.fill.secondary.default))",
					},
					minHeight: "eds.dimension.24",
					paddingBlock: "eds.dimension.4",
					paddingInline: "eds.dimension.12",
				},
				label: {
					textStyle: "buttonSM",
					lineHeight: "18px",
				},
			},
		},
	},
});
